// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"772":"36c1c411","834":"33e61b8e","912":"38e3ed17","966":"3b4f8fa0"}[chunkId] + ".chunk.css";
};